import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class ImageOverlayVC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      trigger: false,
    }
  }

  render() {
    const {
      bgimage,
      customlogo,
      logo,
      content,
      content_color,
      buttonlabel,
      buttontarget,
      buttonlink,
    } = this.props

    return (
      <div
        className={
          'dhsv_vc_image_overlay ' +
          content_color +
          (bgimage ? ' noborder' : ' border')
        }
        style={{ backgroundImage: `url(${bgimage})` }}
      >
        <div className="dhsv_vc_image_overlay_contentholder">
          {customlogo ? (
            <div
              className="dhsv_vc_image_overlay_logo overlay_logo_bg"
              style={{ backgroundImage: `url(${customlogo})` }}
            />
          ) : (
            <div
              className="dhsv_vc_image_overlay_logo"
              dangerouslySetInnerHTML={{ __html: logo }}
            />
          )}
          <div
            className="dhsv_vc_image_overlay_content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          <a
            className="btn dhsv_vc_image_overlay_btn"
            href={buttonlink}
            target={buttontarget}
          >
            {buttonlabel}
          </a>
        </div>
      </div>
    )
  }
}

ImageOverlayVC.propTypes = {
  bgimage: PropTypes.string,
  customlogo: PropTypes.string,
  logo: PropTypes.string,
  content: PropTypes.string,
  content_color: PropTypes.string,
  buttonlabel: PropTypes.string,
  buttontarget: PropTypes.string,
  buttonlink: PropTypes.string,
}

export default ImageOverlayVC
